import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { Privileges, Privilege } from 'UvExplorerServer.Dtos.TS/Auth';


@Component({
    selector: 'share-privileges-editor',
	templateUrl: './share-privileges-editor.component.html',
	styleUrls: ['./share-privileges-editor.component.scss']
})
export class SharePrivilegesEditorComponent {

	@Input()
	public target: Privileges;

	@Input()
	public display: boolean;

	@Output()
	public displayChange: EventEmitter<any>;

	@Output()
	public onOK: EventEmitter<any>;

	@Output()
	public onCancel: EventEmitter<any>;

	public canEnableDisablePorts: boolean;
	public canManagePortPoe: boolean;
	public canEditPortAliases: boolean;
	public canManagePortAccessVlans: boolean;
	public canManageTrunkedVlans: boolean;
	public canViewConfigs: boolean;
	public canManageAgents: boolean;

	constructor() {

		this.target = null;
		this.display = false;
		this.displayChange = new EventEmitter<any>();
		this.onOK = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();
		this.canEnableDisablePorts = false;
		this.canManagePortPoe = false;
		this.canEditPortAliases = false;
		this.canManagePortAccessVlans = false;
		this.canManageTrunkedVlans = false;
		this.canViewConfigs = false;
		this.canManageAgents = false;
	}

	public get enableOK(): boolean {
		return true;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.canEnableDisablePorts = false;
		this.canManagePortPoe = false;
		this.canEditPortAliases = false;
		this.canManagePortAccessVlans = false;
		this.canManageTrunkedVlans = false;
		this.canViewConfigs = false;
		this.canManageAgents = false;

		if (!!this.target) {
			this.canEnableDisablePorts = this.target.Contains(Privilege.PortsEnableDisable);
			this.canManagePortPoe = this.target.Contains(Privilege.PortsManagePoe);
			this.canEditPortAliases = this.target.Contains(Privilege.PortsEditAliases);
			this.canManagePortAccessVlans = this.target.Contains(Privilege.PortsManageAccessVlans);
			this.canManageTrunkedVlans = this.target.Contains(Privilege.ManageTrunkedVlans);
			this.canViewConfigs = this.target.Contains(Privilege.ViewConfigs);
			this.canManageAgents = this.target.Contains(Privilege.ManageAgents);
		}
	}

	public handleOK(): void {
		if (this.canEnableDisablePorts) {
			this.target.Add(Privilege.PortsEnableDisable);
		}
		else {
			this.target.Remove(Privilege.PortsEnableDisable);
		}

		if (this.canManagePortPoe) {
			this.target.Add(Privilege.PortsManagePoe);
		}
		else {
			this.target.Remove(Privilege.PortsManagePoe);
		}

		if (this.canEditPortAliases) {
			this.target.Add(Privilege.PortsEditAliases);
		}
		else {
			this.target.Remove(Privilege.PortsEditAliases);
		}

		if (this.canManagePortAccessVlans) {
			this.target.Add(Privilege.PortsManageAccessVlans);
		}
		else {
			this.target.Remove(Privilege.PortsManageAccessVlans);
		}

		if (this.canManageTrunkedVlans) {
			this.target.Add(Privilege.ManageTrunkedVlans);
		}
		else {
			this.target.Remove(Privilege.ManageTrunkedVlans);
		}

		if (this.canViewConfigs) {
			this.target.Add(Privilege.ViewConfigs);
		}
		else {
			this.target.Remove(Privilege.ViewConfigs);
		}

		if (this.canManageAgents) {
			this.target.Add(Privilege.ManageAgents);
		}
		else {
			this.target.Remove(Privilege.ManageAgents);
		}

		this.hideDialog();
		this.onOK.emit(true);
	}

	public handleCancel(): void {
		this.hideDialog();
		this.onCancel.emit(true);
	}

	public onDialogHide(): void {
		this.handleCancel();
	}

    public displayDialog() {
		this.display = true;
		this.displayChange.emit();
    }

    public hideDialog() {
        this.display = false;
		this.displayChange.emit();
    }

}
